import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import NebulaModuleBase from './module-base';
import ResultInt from '../../_interface/result-int';
import ExecutionResult from '../../uplus-api/container/execution-result';
export var UpShare = function (_NebulaModuleBase) {
    _inherits(UpShare, _NebulaModuleBase);

    function UpShare() {
        _classCallCheck(this, UpShare);

        return _possibleConstructorReturn(this, (UpShare.__proto__ || Object.getPrototypeOf(UpShare)).apply(this, arguments));
    }

    _createClass(UpShare, [{
        key: 'share',
        value: function share(data) {
            return this.generatePromiseByFunctionWithParams('shareContentForSharePlugin', data);
        }
    }, {
        key: 'shareWechatMiniProgram',
        value: function shareWechatMiniProgram(data) {
            return this.generatePromiseByFunctionWithParams('shareMimiProgramForSharePlugin', data);
        }
    }, {
        key: 'showShareView',
        value: function showShareView(data) {
            var _this2 = this;

            return new Promise(function (resolve, reject) {
                var _a;
                if (window && window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf('UpHybrid') !== -1 && data.shareType !== 'webPage') {
                    reject(new ResultInt('150002', '分享类型错误'));
                    return;
                }
                data.image = _this2.replaceVirtualDomainName(data.image);
                data.thumImage = _this2.replaceVirtualDomainName(data.thumImage);
                window.AlipayJSBridge.call('showShareView', {
                    title: data.title,
                    desc: (_a = data.desc) !== null && _a !== void 0 ? _a : '',
                    url: data.url,
                    image: data.image,
                    shareType: data.shareType,
                    thumImage: data.thumImage
                }, function (ret) {
                    var result = new ExecutionResult(ret === null || ret === void 0 ? void 0 : ret.retCode);
                    if (result.retCode === '000000') {
                        resolve(new ResultInt('000000', '分享成功'));
                    } else if (result.retCode === '150001') {
                        reject(new ResultInt('150001', '应用未安装'));
                    } else if (result.retCode === '150003') {
                        reject(new ResultInt('150003', '无图片存储权限'));
                    } else {
                        reject(new ResultInt('000001', '分享失败'));
                    }
                });
            });
        }
    }, {
        key: 'replaceVirtualDomainName',
        value: function replaceVirtualDomainName(path) {
            if (path && path.indexOf('https://virtual.uplus.com/') !== -1) {
                path = path.replace('https://virtual.uplus.com/', '');
            }
            return path;
        }
    }]);

    return UpShare;
}(NebulaModuleBase);